import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./imagegallery-swiper-styles.css";

export const ImageAnimation = (props) => {
    const modelCtx = useContext(ModelContext);

    return (
        <>
            {props.type === "triangle" &&
                <div className="row justify-content-center">
                    <div className="col-12 stage-animation">
                        <div className="row align-items-center position-image-animation">
                            <div className="col-md-6 col-6">
                                <Swiper
                                    modules={[EffectFade, Navigation, Pagination, Autoplay]}
                                    spaceBetween={50}
                                    effect={"fade"}
                                    speed={1500}
                                    loop={true}
                                    autoplay={{
                                        delay: 1500,
                                        disableOnInteraction: false,
                                    }}
                                    fadeEffect={{
                                        crossFade: true,
                                    }}
                                >
                                    <SwiperSlide>
                                        <div className="box text-center">
                                            <img src="images/N50/animazione-triangolo-001.jpg" alt="Exterior 01" className="images-animation" />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className="box text-center">
                                            <img src="images/N50/animazione-triangolo-002.jpg" alt="Exterior 02" className="images-animation" />
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                            <div className="col-md-6 col-6 descriptions">
                                <div className="box">
                                    <div className="text-left color-blue tile d-none d-sm-block">
                                        <p className="title2 wow fadeInUp" data-wow-delay="0.4s">
                                            <br /><br />
                                            Some people<br /> see a triangle...<br /><br />
                                            ... we see <br /> a symbol of majesty.
                                            <br /><br />
                                        </p>
                                    </div>
                                    <div className="text-left color-blue tile">
                                        <p className="text4 wow fadeInUp d-block d-sm-none" data-wow-delay="0.4s">
                                            Some people<br /> see a <strong>triangle</strong>...<br />
                                            ... we see <br /> a symbol of <strong>majesty</strong>.
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.type === "ellipse" &&
                <div className="row justify-content-center">
                    <div className="col-12 stage-animation">
                        <div className="row align-items-center position-image-animation">
                            <div className="col-md-6 col-6">
                                <Swiper
                                    modules={[EffectFade, Navigation, Pagination, Autoplay]}
                                    spaceBetween={50}
                                    effect={"fade"}
                                    speed={1500}
                                    loop={true}
                                    autoplay={{
                                        delay: 1500,
                                        disableOnInteraction: false,
                                    }}
                                    fadeEffect={{
                                        crossFade: true,
                                    }}
                                >
                                    <SwiperSlide>
                                        <div className="box text-center">
                                            <img src="images/N50/animazione-ellisse-001.jpg" alt="Interior 01" className="images-animation" />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className="box text-center">
                                            <img src="images/N50/animazione-ellisse-002.jpg" alt="Interior 02" className="images-animation" />
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                            <div className="col-md-6 col-6 descriptions">
                                <div className="box">
                                    <div className="text-left color-blue tile d-none d-sm-block">
                                        <p className="title2 wow fadeInUp" data-wow-delay="0.4s">
                                            <br /><br />
                                            Some people see<br /> an ellipse...<br /><br />
                                            ... we see<br /> a space of pure comfort.
                                            <br /><br />
                                        </p>
                                    </div>
                                    <div className="text-left color-blue tile d-block d-sm-none">
                                        <p className="text4 wow fadeInUp" data-wow-delay="0.4s">
                                            Some people see<br /> an <strong>ellipse</strong>...<br />
                                            ... we see<br /> a space of <strong>pure comfort</strong>.
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.type === "owner" &&
                <>
                    <div className="row justify-content-center m-5 d-none d-lg-block">
                        <p>&nbsp;</p>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 stage-animation">
                            <div className="row align-items-center position-image-animation">
                                <div className="col-md-12 col-12">
                                    <Swiper
                                        modules={[EffectFade, Navigation, Pagination, Autoplay]}
                                        spaceBetween={50}
                                        effect={"fade"}
                                        speed={2500}
                                        loop={true}
                                        autoplay={{
                                            delay: 3500,
                                            disableOnInteraction: false,
                                        }}
                                        fadeEffect={{
                                            crossFade: true,
                                        }}
                                    >
                                        <SwiperSlide>
                                            <div className="box text-center">
                                                <img src="images/N50/animazione-owner-001.jpg" alt="Owner 01" className="images-animation-w100" />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="box text-center">
                                                <img src="images/N50/animazione-owner-002.jpg" alt="Owner 02" className="images-animation-w100" />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center m-5 d-none d-lg-block">
                        <p>&nbsp;</p>
                    </div>
                </>
            }
        </>
    );
};

export default ImageAnimation;
